import type * as React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Empty block (DESIGN_SYSTEM §4): 56 px sunken icon tile, 18/26 title, muted hint, optional
 * actions (one primary, at most one secondary).
 */
function EmptyState({
  icon: Icon,
  title,
  hint,
  action,
  titleAs: Title = 'p',
  className,
}: {
  icon: LucideIcon;
  title: React.ReactNode;
  hint?: React.ReactNode;
  action?: React.ReactNode;
  /** Render the title as a heading when the empty block is the page's main content. */
  titleAs?: 'p' | 'h2' | 'h3';
  className?: string;
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn('flex flex-col items-center gap-2 px-6 py-12 text-center', className)}
    >
      <span className="mb-2 flex size-14 items-center justify-center rounded-lg bg-surface-muted text-muted-foreground">
        <Icon className="size-7" aria-hidden="true" />
      </span>
      <Title className="text-h3 text-foreground">{title}</Title>
      {hint ? <p className="max-w-prose text-body text-muted-foreground">{hint}</p> : null}
      {action ? (
        <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{action}</div>
      ) : null}
    </div>
  );
}

export { EmptyState };
